import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, mb: 2.5, flexWrap: 'wrap' }}>
      {/*
        ⚠️ **`minWidth: '100%'` at xs, and it is what stops the title column
        collapsing.** The row wraps, but only if some child is willing to take
        the whole line — and `minWidth: 0` made the TEXT the thing that gave
        way: a page with wide actions squeezed its subtitle to about seventy
        pixels and wrapped it ONE WORD PER LINE, a paragraph rendered as a
        column. Forcing the text to a full row at phone width pushes the
        actions below it instead, which is where they belong.

        Above xs it is `minWidth: 0` exactly as before, so nothing about the
        desktop layout of the twenty-odd pages using this moves. Found by
        screenshotting a 430px viewport.
      */}
      <Box sx={{ flex: 1, minWidth: { xs: '100%', sm: 0 } }}>
        <Typography variant="h2" component="h1">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box>}
    </Box>
  );
}
